__turbopack_context__.v({
  "className": "archivo_narrow_b6e168a5-module__wDlAjG__className",
  "variable": "archivo_narrow_b6e168a5-module__wDlAjG__variable",
});
